const PrivacyPolicy = () => {
  return (
    <div className="max-w-5xl mx-auto px-6 py-16 text-gray-800">

      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="text-sm text-gray-500 mb-8">
        Last Updated: 05 April 2026
      </p>

      <p className="mb-6 leading-relaxed">
        Beneicon respects your privacy and is committed to protecting the personal 
        information you provide when using our website. This Privacy Policy explains 
        how we collect, use, store, and protect your information when you visit the 
        Beneicon website.
      </p>

      <p className="mb-8 font-medium">
        By accessing or using this website, you agree to the terms of this Privacy Policy.
      </p>

      {/* Section 1 */}
      <h2 className="text-xl font-semibold mb-3">1. Information We Collect</h2>

      <h3 className="font-semibold mb-2">Personal Information</h3>
      <p className="mb-4 leading-relaxed">
        Personal information may be collected when you voluntarily provide it through 
        forms or inquiries. This may include:
      </p>
      <ul className="list-disc pl-6 mb-6 space-y-2">
        <li>Full Name</li>
        <li>Email Address</li>
        <li>Phone Number</li>
        <li>Company Name</li>
        <li>Business or industry details</li>
        <li>Project requirements or inquiry details</li>
      </ul>

      <p className="mb-4">This information is typically collected when you:</p>
      <ul className="list-disc pl-6 mb-8 space-y-2">
        <li>Submit a contact form</li>
        <li>Request a product demo or quotation</li>
        <li>Inquire about LED display solutions</li>
        <li>Communicate with our team</li>
      </ul>

      <h3 className="font-semibold mb-2">Non-Personal Information</h3>
      <p className="mb-4 leading-relaxed">
        We may also collect non-personal information automatically when you visit 
        our website, including:
      </p>
      <ul className="list-disc pl-6 mb-8 space-y-2">
        <li>IP address</li>
        <li>Browser type</li>
        <li>Device information</li>
        <li>Pages visited</li>
        <li>Time spent on the website</li>
        <li>Website navigation behavior</li>
      </ul>

      {/* Section 2 */}
      <h2 className="text-xl font-semibold mb-3">2. How We Use Your Information</h2>
      <p className="mb-4">Beneicon may use the information collected for:</p>
      <ul className="list-disc pl-6 mb-8 space-y-2">
        <li>Responding to inquiries, demo requests, or quotations</li>
        <li>Providing information about our products and services</li>
        <li>Processing business inquiries and sales communication</li>
        <li>Improving website functionality and user experience</li>
        <li>Analyzing website traffic and visitor behavior</li>
        <li>Enhancing marketing and advertising (including Meta & Google Ads)</li>
      </ul>

      {/* Section 3 */}
      <h2 className="text-xl font-semibold mb-3">3. Cookies and Tracking Technologies</h2>
      <p className="mb-4 leading-relaxed">
        Beneicon may use cookies and similar technologies to enhance browsing 
        experience and analyze website usage.
      </p>
      <p className="mb-4">Cookies help us:</p>
      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>Improve website performance</li>
        <li>Understand visitor behavior</li>
        <li>Optimize website content and navigation</li>
        <li>Run and optimize advertising campaigns</li>
      </ul>
      <p className="mb-8 leading-relaxed">
        You can disable cookies through your browser settings.
      </p>

      {/* Section 4 */}
      <h2 className="text-xl font-semibold mb-3">4. Information Sharing</h2>
      <p className="mb-4 leading-relaxed">
        Beneicon does not sell, rent, or trade personal information to third parties.
      </p>
      <p className="mb-4">We may share information with trusted providers such as:</p>
      <ul className="list-disc pl-6 mb-8 space-y-2">
        <li>Website hosting providers</li>
        <li>Analytics platforms (e.g., Google Analytics)</li>
        <li>Advertising platforms (e.g., Meta Ads, Google Ads)</li>
        <li>CRM and communication tools</li>
      </ul>

      {/* Section 5 */}
      <h2 className="text-xl font-semibold mb-3">5. Data Security</h2>
      <p className="mb-8 leading-relaxed">
        Beneicon takes reasonable technical and organizational measures to protect 
        personal information. However, no method of internet transmission or storage 
        is completely secure, and users share information at their own discretion.
      </p>

      {/* Section 6 */}
      <h2 className="text-xl font-semibold mb-3">6. Third-Party Websites</h2>
      <p className="mb-8 leading-relaxed">
        Our website may contain links to external websites not operated by Beneicon. 
        We are not responsible for their privacy practices, and users should review 
        their policies separately.
      </p>

      {/* Section 7 */}
      <h2 className="text-xl font-semibold mb-3">7. Data Retention</h2>
      <p className="mb-8 leading-relaxed">
        Beneicon retains personal information only as long as necessary to fulfill 
        the purposes outlined in this policy or as required by law.
      </p>

      {/* Section 8 */}
      <h2 className="text-xl font-semibold mb-3">8. Your Rights</h2>
      <p className="mb-4">Depending on your location, you may have rights such as:</p>
      <ul className="list-disc pl-6 mb-8 space-y-2">
        <li>Access your personal data</li>
        <li>Correct inaccurate information</li>
        <li>Request deletion of your data</li>
        <li>Restrict data processing</li>
      </ul>

      {/* Section 9 */}
      <h2 className="text-xl font-semibold mb-3">9. Updates to This Policy</h2>
      <p className="mb-8 leading-relaxed">
        Beneicon may update this Privacy Policy from time to time. Updates will be 
        posted on this page with a revised "Last Updated" date.
      </p>

      {/* Section 10 */}
      <h2 className="text-xl font-semibold mb-3">10. Contact Information</h2>
      <p className="mb-2">If you have any questions, please contact:</p>
      <p className="mb-2 font-medium">Beneicon</p>
      <p className="mb-2">Email: support@beneicon.com</p>
      <p>Website: www.beneicon.com</p>

    </div>
  );
};

export default PrivacyPolicy;